import type { CalculatorReport } from '#/modules/salaries/types/CalculatorReport';
import type { EstimatedRange } from '#/modules/salaries/types/EstimatedRange';
import type { SalariesReportFormData } from '#/modules/salaries/types/SalariesReportFormData';
import type { SubmissionData } from '#/modules/salaries/types/SubmissionData';
import { SALARIES_API_ENDPOINT_ROOT } from '#/modules/salaries/utils/constants/salariesApiEndpointRoot';
import type { BackgroundTask } from '#/utils/asyncBackendTask/asyncBackendTaskTypes';
import { waitTaskCompleted } from '#/utils/asyncBackendTask/waitTaskCompleted';
import { postJson } from '#/utils/http/postJson';

async function fetchSubmissions(
  data: SalariesReportFormData,
): Promise<SubmissionData> {
  return postJson<{ submissionData: SubmissionData }>(
    `${SALARIES_API_ENDPOINT_ROOT}/calculator/submissions`,
    data,
  ).then(({ submissionData }) => submissionData);
}

async function fetchEstimatedRange(
  data: SalariesReportFormData,
): Promise<BackgroundTask<{ estimatedRange: EstimatedRange }>> {
  return postJson<{
    task: BackgroundTask<{ estimatedRange: EstimatedRange }>;
  }>(`${SALARIES_API_ENDPOINT_ROOT}/calculator/estimated-range`, data).then(
    ({ task }) => task,
  );
}

export async function salariesFetchReport(
  values: SalariesReportFormData,
): Promise<CalculatorReport> {
  const [submissionData, reportTask] = await Promise.all([
    fetchSubmissions(values),
    fetchEstimatedRange(values),
  ]);

  const { estimatedRange } = await waitTaskCompleted(reportTask);
  return { submissionData, estimatedRange };
}
